Vendd.Scripts.load(function () {
    'use strict';

    var load = function () {

        var $form = $(".js-edit-address-group-form");

        if ($form.length < 1) return;

        var form = $form.get(0);

        var model = null, formData, af;

        var $html = null;
        var literalsModel = {};

        var validationOptions = {};

        form.update = function () {
            var html = Vendd.Handlebars.parse("accountAddressGroupEditBox_A", model);
            form.initFormData();
            form.bind(html);
        };

        form.bind = function (html) {

            $form.html(html);

            literalsModel = model.Literals;

            $('.js-required', $form).each(function (e, el) {
                var inputName = $('input, select, textarea', el).attr('name');
                validationOptions[inputName] = {
                    required: inputName + '-required'
                };
            });

            $form.validationEngine(validationOptions);
            af = $form.data('validationEngine');

            //open fancybox
            $.fancybox.open($form, {
                clickSlide: false,
                clickOutside: false,
                touch: false,
                keyboard: false,
                beforeClose: function (instance, current) {
                    af.destroy();
                }
            });

            $form.show();
        };

        form.initFormData = function () {
            formData = {
                name: model.Name,
                description: model.Description
            };
        };

        $form.on('keyup', 'input[name]', function (e) {
            var $this = $(this);
            var fieldName = $this.attr('name');

            formData[fieldName] = $this.val();

            $('.address-group-already-exists', $form).hide();
            af.validate(fieldName);
        });

        $form.on('click', '.js-submit-button', function (id) {
            var status = af.validate();

            if (status) {
                $('input[name]:not([type="checkbox"]):not([type="radio"]), select[name]', $form).each(function () {
                    formData[$(this).attr('name')] = omitScriptTag($(this).val());
                });

                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.CheckAddressGroupIfExists(
                    model.Id,
                    formData.name,
                    formData.description
                ));
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.OpenAddressGroupEditForm, form, function (envelope) {
            model = envelope.message.data.model;
            form.update();
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.EditAddressGroupSuccess, form, function (envelope) {
            Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.AddressGroupModelChanged());
            $form.hide();
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.CheckAddressGroupIfExistsSuccess, form, function (envelope) {
            var resolvedModel = envelope.message.data.model;

            if (resolvedModel && 0 < resolvedModel.Id && model.Id <= 0) {
                $('.address-group-already-exists', $form).show();
            }
            else {
                $.fancybox.close();
                Vendd.MessageBus.publishAsync(form, new Vendd.Account.Messages.EditAddressGroup(
                    model.Id,
                    formData.name,
                    formData.description
                ));
            }
        });

        Vendd.MessageBus.subscribe(Vendd.Account.Messages.CheckAddressGroupIfExistsFailure, form, function (envelope) { });
    };

    load();
});
